import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CyclesTable from "./CyclesTable";
import Button from "components/Button";
import { AppraisalCycle } from "types/appraisal-cycle-types";
import { getAllAppraisalCyclesAPI } from "api/apiHelper";

const AppraisalCycleTab = () => {
  const navigate = useNavigate();
  const [cycles, setCycles] = useState<AppraisalCycle[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState<boolean | undefined>(undefined);

  const fetchCycles = async () => {
    try {
      setIsLoading(true);
      const response = await getAllAppraisalCyclesAPI(activeFilter);
      setCycles(response.data || []);
    } catch (error) {
      console.error("Error fetching cycles:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCycles();
  }, [activeFilter]);

  return (
    <div className="mt-5">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex gap-2">
          <Button
            varient={activeFilter === undefined ? "primary" : "secondary"}
            onClick={() => setActiveFilter(undefined)}
            className="px-4 py-2"
          >
            All
          </Button>
          <Button
            varient={activeFilter === true ? "primary" : "secondary"}
            onClick={() => setActiveFilter(true)}
            className="px-4 py-2"
          >
            Active
          </Button>
          <Button
            varient={activeFilter === false ? "primary" : "secondary"}
            onClick={() => setActiveFilter(false)}
            className="px-4 py-2"
          >
            Inactive
          </Button>
        </div>
        <Button
          varient="primary"
          onClick={() => navigate("/admin-appraisals/cycles/create")}
          className="px-6 py-2"
        >
          Create Cycle
        </Button>
      </div>
      <CyclesTable 
        cycles={cycles} 
        isLoading={isLoading} 
        onRefresh={fetchCycles}
      />
    </div>
  );
};

export default AppraisalCycleTab;
